<!-- Row Number -->
<td class="col-row">
    <div class="row-number">{{ row.rowNumber }}</div>
</td>

<!-- Order Number -->
<td class="col-order-no">
    <div class="input-wrapper">
        <input type="text" class="form-input" placeholder="Order Number" title="Order Number"
            (keydown)="isAlphaNumeric($event)" [(ngModel)]="row.orderNo" (focus)="onRowFocus()">
    </div>
</td>

<!-- Warehouse -->
<td class="col-warehouse">
    <select class="form-select" [(ngModel)]="row.warehouse" title="Select Warehouse" (focus)="onRowFocus()" (change)="onWarehouseChange(row)">
        <option *ngFor="let opt of warehouseOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
</td>

<!-- Company Name -->
<td class="col-company-name">
    <div class="input-wrapper combo-wrapper">
        <input type="text" class="form-input" [class.new-company]="row.isCompanyNew" placeholder="Company Name" title="Company Name"
            [(ngModel)]="row.companyName" (focus)="openCompanyDropdown()" (input)="filterCompanies()"
            (keydown)="onCompanyKeydown($event)" (blur)="closeCompanyDropdown()" />

        <!-- Badge rendered BEFORE + button so it sits on top in stacking context -->
        <div class="match-badge company-match-badge" [class.with-add-btn]="row.isCompanyNew"
            *ngIf="row.isCompanyNew && row.matchingCompanies && row.matchingCompanies.length > 0"
            title="Click to see alternatives"
            (mousedown)="$event.preventDefault(); toggleCompanyDropdown()">
            {{ row.matchingCompanies.length }}
        </div>

        <button *ngIf="row.isCompanyNew" type="button" class="info-button"
            (click)="$event.stopPropagation(); addNewCompany()" [disabled]="isAddingCompany" title="Add New Company">
            <i *ngIf="isAddingCompany" class="fa fa-spinner fa-spin" style="font-size: 11px;"></i>
            <svg *ngIf="!isAddingCompany" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
        </button>

        <div class="combo-dropdown-icon" [class.active-matches]="row.isCompanyNew && row.matchingCompanies && row.matchingCompanies.length > 0"
            (mousedown)="$event.preventDefault(); toggleCompanyDropdown()" style="cursor:pointer;">
            <svg class="icon icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
        </div>

        <div class="combo-dropdown" *ngIf="row.showCompanyDropdown">
            <div class="combo-option" *ngIf="isCompanySearching" style="font-style: italic; color: #6c757d; pointer-events: none; text-align: center;">
                <small>Searching...</small>
            </div>
            <ng-container *ngIf="!isCompanySearching">
                <div class="combo-option" *ngFor="let company of row.filteredCompanies; let i = index"
                    [class.active]="i === row.highlightedCompanyIndex" 
                    (mousemove)="onMouseMove($event, i, 'company')"
                    (mousedown)="selectCompany(company)">
                    {{ company.company }}
                </div>
            </ng-container>
        </div>
    </div>
</td>

<!-- Company Address -->
<td class="col-company-address">
    <div class="input-wrapper combo-wrapper">
        <input type="text" class="form-input" [class.new-address]="row.isAddressNew || (!row.addressId && row.companyAddress && (row.fromDispatchSheet || !!row.row_uuid))" placeholder="Company Address" title="Company Address"
            [(ngModel)]="row.companyAddress" (input)="filterAddresses()" (keydown)="onAddressKeydown($event)"
            (blur)="closeAddressDropdown()" (focus)="openAddressDropdown()" />

        <!-- Badge rendered BEFORE + button so it sits on top in stacking context -->
        <div class="match-badge address-match-badge" [class.with-add-btn]="row.isAddressNew || row.showAddButton || (!row.addressId && row.companyAddress && (row.fromDispatchSheet || !!row.row_uuid))"
            *ngIf="row.isAddressNew && row.matchingAddresses && row.matchingAddresses.length > 0"
            title="Click to see alternatives"
            (mousedown)="$event.preventDefault(); toggleAddressDropdown()">
            {{ row.matchingAddresses.length }}
        </div>

        <button *ngIf="row.isAddressNew || row.showAddButton || (!row.addressId && row.companyAddress && (row.fromDispatchSheet || !!row.row_uuid))" type="button" class="info-button"
            (click)="$event.stopPropagation(); onAddAddressClick()" title="Add New Address">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
        </button>

        <div class="combo-dropdown-icon" [class.active-matches]="row.isAddressNew && row.matchingAddresses && row.matchingAddresses.length > 0"
            (mousedown)="$event.preventDefault(); toggleAddressDropdown()" style="cursor:pointer;">
            <svg class="icon icon-sm" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
        </div>

        <div class="combo-dropdown" *ngIf="row.showAddressDropdown">
            <div class="combo-option" *ngIf="isAddressSearching" style="font-style: italic; color: #6c757d; pointer-events: none; text-align: center;">
                <small>Searching...</small>
            </div>
            <ng-container *ngIf="!isAddressSearching">
                <div class="combo-option" *ngFor="let address of row.filteredAddressOptions; let i = index"
                    [class.active]="i === row.highlightedAddressIndex" 
                    (mousemove)="onMouseMove($event, i, 'address')"
                    (mousedown)="selectAddress(address)">
                    {{ address.address }}
                </div>
            </ng-container>
        </div>
    </div>
</td>

<!-- Contact Name -->
<td class="col-contact-name">
    <div class="input-wrapper">
        <input type="text" class="form-input" [class.error]="!isContactNameValid(row.contactName)"
            placeholder="Contact Name" title="Contact Name" [(ngModel)]="row.contactName"
            (input)="onContactNameInput($event)">
        <div class="error-text" [class.show]="!isContactNameValid(row.contactName)">
            Name must start with a capital letter
        </div>
    </div>
</td>

<!-- Country Code -->
<td class="col-country-code">
    <select class="form-select" [(ngModel)]="row.countryCode" title="Select Country Code" (ngModelChange)="onCountryCodeChange($event)">
        <option *ngFor="let opt of countryCodeOptions" [value]="opt.dial_code">
            {{ opt.code }} {{ opt.dial_code }}
        </option>
    </select>
</td>

<!-- Phone Number -->
<td class="col-phone">
    <div class="input-wrapper">
        <input type="tel" class="form-input" [class.error]="!isPhoneValid(row.phone)" placeholder="Ph Number"
            title="Phone Number" maxlength="10" [(ngModel)]="row.phone" (input)="onPhoneInput('phone', $event)"
            (keypress)="isNumberKey($event)" (ngModelChange)="onPhoneChange($event)">
        <div class="error-text" [class.show]="!isPhoneValid(row.phone)">
            Phone must be 10 digits
        </div>
    </div>
</td>

<!-- Alt Phone Number -->
<td class="col-alt-phone">
    <div class="input-wrapper">
        <input type="tel" class="form-input" [class.error]="!isPhoneValid(row.altPhone)"
            placeholder="Alternate Ph Number" title="Alternate Phone Number" maxlength="10" [(ngModel)]="row.altPhone"
            (keypress)="isNumberKey($event)" (input)="onPhoneInput('altPhone', $event)">
        <div class="error-text" [class.show]="!isPhoneValid(row.altPhone)">
            Phone must be 10 digits
        </div>
    </div>
</td>

<!-- Email -->
<td class="col-email">
    <div class="input-wrapper">
        <input type="email" class="form-input" [class.error]="!isEmailValid(row.email)" placeholder="Email"
            title="Email Address" [(ngModel)]="row.email">
        <div class="error-text" [class.show]="!isEmailValid(row.email)">
            Please enter a valid email
        </div>
    </div>
</td>

<!-- Delivery Date -->
<td class="col-delivery-date">
    <input type="date" class="form-date" [(ngModel)]="row.deliveryDate" [min]="minDate" title="Delivery Date">
</td>

<!-- Pickup Date -->
<td class="col-pickup-date">
    <input type="date" class="form-date" [(ngModel)]="row.pickupDate" [min]="minDate" title="Pickup Date">
</td>

<!-- Delivery Time -->
<td class="col-delivery-time">
    <div class="input-wrapper">
        <input class="form-time mb-0" placeholder="--:-- --" title="Delivery Time" readonly matInput [format]="12"
            [ngxTimepicker]="delyTimePicker" [(ngModel)]="row.deliveryTime" (keydown.enter)="$event.preventDefault()">
        <ngx-material-timepicker #delyTimePicker [defaultTime]="getTime()" [format]="12"
            (timeSet)="onDelyTimeSet($event)"></ngx-material-timepicker>
        <span [style.visibility]="row.deliveryTime ? 'visible' : 'hidden'" class="remove-time"
            (click)="removeTimedely()" title="Remove Time">&times;</span>
    </div>
</td>

<!-- Pickup Time -->
<td class="col-pickup-time">
    <div class="input-wrapper">
        <input class="form-time mb-0" placeholder="--:-- --" title="Pickup Time" readonly matInput [format]="12"
            [ngxTimepicker]="pickupTimePicker" [(ngModel)]="row.pickupTime" (keydown.enter)="$event.preventDefault()">
        <ngx-material-timepicker #pickupTimePicker [defaultTime]="getTime()" [format]="12"
            (timeSet)="onPickupTimeSet($event)"></ngx-material-timepicker>
        <span [style.visibility]="row.pickupTime ? 'visible' : 'hidden'" class="remove-time" (click)="removeTime()"
            title="Remove Time">&times;</span>
    </div>
</td>

<!-- Service Time -->
<td class="col-service-time">
    <select class="form-select" [(ngModel)]="row.serviceTime" title="Select Service Time">
        <option *ngFor="let opt of serviceTimeOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
</td>

<!-- Driver Name -->
<td class="col-driver-name" *ngIf="driverOptions && driverOptions.length">
    <app-driver-select 
        [options]="driverOptions" 
        [(ngModel)]="row.driver_id"
        placeholder="Select Driver">
    </app-driver-select>
</td>

<!-- Sign Required -->
<td class="col-sign-req">
    <select class="form-select" [(ngModel)]="row.signReq" (ngModelChange)="onSignReqChange()"
        title="Signature Required">
        <option *ngFor="let opt of yesNoOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
</td>

<!-- Del/PU -->
<td class="col-delpju">
  <div class="combo-wrapper delpu-custom-dropdown">
    <div class="form-select custom-select-trigger"
         (click)="toggleDelpuDropdown()"
         (blur)="closeDelpuDropdown()"
         tabindex="0">
      {{ row.delPU === 0 || row.delPU === null || row.delPU === undefined ? 'Select' : row.delPU }}
    </div>
    <div class="combo-dropdown delpu-dropdown" [class.show]="showDelpuDropdown">
      <div class="combo-option" (mousedown)="$event.preventDefault(); selectDelpu(0)">Select</div>
      <div class="combo-option" *ngFor="let opt of visibleDelpuOptions; let last = last"
           [class.disabled]="opt.disabled"
           (mousedown)="$event.preventDefault(); !opt.disabled && selectDelpu(opt.value)">
        <span>{{ opt.label }}</span>
        <span class="plus-icon inline-plus"
              *ngIf="last && visibleDelpuCount < delpuOptions.length"
              (mousedown)="$event.preventDefault(); loadMoreDelpu($event)">+</span>
      </div>
    </div>
  </div>
</td>

<!-- Note -->
<td class="col-note">
    <input type="text" class="form-input" placeholder="Notes" title="Notes" [(ngModel)]="row.note">
</td>

<!-- Actions (Delete) -->
<td class="col-actions">
    <button class="delete-btn" (click)="onDeleteRow()" title="Delete Row">
        <svg fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                clip-rule="evenodd" />
        </svg>
    </button>
</td>
